import { render, staticRenderFns } from "./passwordBind.vue?vue&type=template&id=354bced6&scoped=true"
import script from "./passwordBind.vue?vue&type=script&lang=ts&scoped=true"
export * from "./passwordBind.vue?vue&type=script&lang=ts&scoped=true"
import style0 from "./passwordBind.vue?vue&type=style&index=0&id=354bced6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354bced6",
  null
  
)

export default component.exports